import { Equipment } from '../../Models/Equipment';
import { EquipmentFeature } from '../../Models/EquipmentFeature';
import { formatNumbers } from '../../Utils';

export default function ProductFeatures({
  features,
}: {
  features: EquipmentFeature[];
}) {
  return (
    <div>
      <div className='container mx-auto p-2'>
        <div className='text-black'>
          {features.map((feature) => (
            <div className='specsInfo'>
              <div className='flex'>
                <div className='font-bold'>{feature.featureName}:</div>
              </div>
              <div className='pl-1 text-black'>{feature.description}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
